import { FormComponentType } from "@/components/forms/Form/convertFormData";
import { useStore } from "@/store";
import { computed, ref, Ref } from "vue";

/**
 * Innehåller exposes och andra värden som används bland alla våra K-inputs. Används för att slippa duplicerad kod
 */
export const useInputHelpers = <CONVERTVALUE, CONVERTRETURN>({
    disabled,
    readonly,
    suffixText,
    suffixType,
    ignoreValue,
    kType,
    convertData,
    configNames,
    name,
    ignoreEmptyData,
    shouldBeVisible,
}: {
    name: string;
    disabled?: boolean;
    readonly?: boolean;
    suffixText?: string;
    suffixType?: "info" | "info-dark" | "note";
    ignoreValue?: boolean;
    kType?: FormComponentType;
    convertData?: (props: { value: CONVERTVALUE }) => CONVERTRETURN;
    configNames?: {
        moduleName: string;
        subModuleName: string;
    };
    ignoreEmptyData?: boolean;
    shouldBeVisible?: Ref<boolean | undefined>;
}) => {
    const store = useStore();

    const modifiedDisabled = ref(disabled);
    const modifiedReadonly = ref(readonly);
    const modifiedSuffix = ref(suffixText);
    const modifiedSuffixType = ref(suffixType);

    const internalShouldBeVisible = computed(() =>
        store.getters["config/shouldBeVisibleByName"]({
            ...(configNames ?? {}),
            name,
            overrideValue: shouldBeVisible?.value,
        })
    );

    const setDisabled = ({ value }: { value: boolean }) => {
        modifiedDisabled.value = value;
    };

    const setReadonly = ({ value }: { value: boolean }) => {
        modifiedReadonly.value = value;
    };

    const setSuffix = ({ value }: { value: string | undefined }) => {
        modifiedSuffix.value = value;
    };

    const setSuffixType = ({ value }: { value: "info" | "info-dark" | "note" }) => {
        modifiedSuffixType.value = value;
    };

    return {
        modifiedReadonly,
        modifiedDisabled,
        modifiedSuffix,
        modifiedSuffixType,
        shouldBeVisible: internalShouldBeVisible,
        expose: {
            setDisabled,
            setReadonly,
            setSuffix,
            setSuffixType,
            kType,
            convertData,
            ignoreValue: () => ignoreValue,
            ignoreEmptyData: () => ignoreEmptyData,
        },
    };
};
